import React from 'react';
import style from './flightPlanTrack.module.scss';
import classNames from 'classnames';
import { Location } from 'acscp/store';
import moment from 'moment';
import { Duration } from 'acscp/components/common/duration';
import { addZeroWidthSpacesAroundSeparatorCharacters } from 'acscp/components/common/helpers/stringHelpers';
import TruncateLines from 'acscp/components/common/truncateLines';

export interface Node {
    render: (index: number) => JSX.Element;
    renderTextNode: (index: number) => JSX.Element;
}

export class AirportNode implements Node, Location {
    private isHop: boolean = false;
    constructor(readonly location: string,
                readonly airportId: string | null) {}

    markAsHop(): AirportNode {
        this.isHop = true;
        return this;
    }

    render(index: number): JSX.Element {
        return (
            <div key={index} className={classNames(style.AirportNode, {[style.AirportNodeHop]: this.isHop})}>
                <div className={style.AirportLabel}>
                    <TruncateLines
                        text={addZeroWidthSpacesAroundSeparatorCharacters(this.location).toUpperCase()}
                        lines={1}
                    />
                </div>
            </div>
        );
    }
    renderTextNode(index: number): JSX.Element {
        return (
            <div key={index} className={style.AirportText}>
                {addZeroWidthSpacesAroundSeparatorCharacters(this.location)}
            </div>
        );
    }
}

export class DurationNode implements Node {
    constructor(
        private duration: moment.Duration | null,
        private register: (ref: HTMLDivElement | null) => void,
        private isEmpty: boolean = false,
        private isExpanded: boolean = false,
    ) {}

    render(index: number): JSX.Element {
        return (
            <div
                key={index}
                className={classNames(
                    {
                        [style.DurationNode]: !this.isExpanded,
                        [style.ExpandedDurationNode]: this.isExpanded,
                        [style.DurationNodeEmpty]: this.isEmpty
                    })}
                ref={div => this.register(div)}
            >
                <div className={style.DurationLabel}>
                    <Duration duration={this.duration} />
                </div>
            </div>
        );
    }
    renderTextNode(index: number): JSX.Element {
        return (
            <div key={index}>-</div>
        );
    }
}

// An empty duration corresponds to a 'gap' between legs for which there is no corresponding flight.
export class EmptyDurationNode extends DurationNode {
    constructor(register: (ref: HTMLDivElement | null) => void) {
        super(null, register, true);
    }
}

// A blank duration corresponds to a flight for which we do not wish to display a duration label
export class BlankDurationNode extends DurationNode {
    constructor(register: (ref: HTMLDivElement | null) => void) {
        super(null, register);
    }
}

// A duration that stretches to fill the whole row.
export class ExpandedDurationNode extends DurationNode {
    constructor(duration: moment.Duration | null, register: (ref: HTMLDivElement | null) => void) {
        super(duration, register, false, true);
    }
}
